//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TooltipMixins from "../mixins/tooltip";
export default {
  mixins: [TooltipMixins],
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      tooltip: {}
    };
  },
  methods: {
    $ready: function $ready() {
      this.tooltip = this.spec.tooltip || {
        disabled: true
      };
    }
  }
};